(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/text/text.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/text/text.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.text = svs.tur.payfooter.text || {};
class Default extends svs.tur.Base {
  constructor(options) {
    super(options);
    this.log = new svs.core.log.Logger('betslip:payfooter:text');
    this.amountHandler = new svs.tur.payfooter.Amount({
      title: this.text
    });
    this.createDomElements();
  }
  addEventHandler(eh) {
    if (this.amountHandler && this.listenOn) {
      eh.on(this.listenOn, data => {
        this.update(data);
      });
    }
  }
  createDomElements() {
    if (this.amountHandler) {
      this.$el.appendChild(this.amountHandler.render());
    } else {
      this.$el.innerHTML = this.text;
    }
  }
  classNames() {
    return ['payfooter-text'];
  }
  update(_ref) {
    let amount = _ref.amount,
      _ref$animate = _ref.animate,
      animate = _ref$animate === void 0 ? true : _ref$animate,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      forceDim = _ref.forceDim;
    if (animate) {
      this.amountHandler.update(amount, text, forceDim);
    } else {
      this.amountHandler.set(amount, text);
    }
  }
  render() {
    return this.$el;
  }
}
svs.tur.payfooter.text.Default = Default;

 })(window);